import {injectable} from "tsyringe";
import {SaveKnowledgeObjectContentCommand, SaveKnowledgeObjectContentPayload} from "../commands/save-knowledge-object-content.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

/**
 * Maps `SaveKnowledgeObjectContentCommand` to the backend command DTO.
 *
 * The payload here is a plain `{ objectUid, payload }` value object — NOT a
 * proxified entity — so the generic command-to-dto fallback (which insists on
 * a ChangeTracker proxy) does not apply. Backend handler reads
 * `payload.objectUid` (ShortId or UUID) and `payload.payload` (BoardObject[]).
 */
@injectable()
@transformer({
    source: SaveKnowledgeObjectContentCommand,
    target: `dto`
})
export class SaveKnowledgeObjectContentCommandToDtoTransformer extends AbstractCommandToDtoTransformer<SaveKnowledgeObjectContentPayload> {

    protected async toDTO(payload: SaveKnowledgeObjectContentPayload): Promise<DataTransferObject> {
        return {
            objectUid: payload.objectUid,
            payload: payload.payload,
        } as unknown as DataTransferObject;
    }
}
